module.exports = __webpack_public_path__ + "static/smiley-25b1e6f0627feb79d2b5acfad6f36147.gif";